/* istanbul ignore file */
import * as React from 'react'
import PropTypes from 'prop-types'

function IconGrowingPlant({ srText, size = 'md', className = '', ...props }) {
  const newClassName = `mc-icon mc-icon--${size} ${className}`
  return (
    <>
      {!!srText && <span className='mc-sr-only'>{srText}</span>}
      <svg
        xmlns='http://www.w3.org/2000/svg'
        width={24}
        height={24}
        viewBox='0 0 24 24'
        aria-hidden='true'
        role='img'
        className={newClassName}
        {...props}
      >
        <path
          fill='none'
          strokeWidth={1.5}
          strokeLinecap='round'
          strokeLinejoin='round'
          stroke='currentColor'
          d='M12.608 14.392a2.402 2.402 0 0 1 1.015 3.22c-.29.563-.791.987-1.393 1.181a2.386 2.386 0 0 1-1.82-.135A15.112 15.112 0 0 1 7.388 15.2a.8.8 0 0 1-.057-.83.792.792 0 0 1 .708-.436 14.98 14.98 0 0 1 4.57.457ZM13.588 17.727a5.437 5.437 0 0 1 1.749 2.569M24.675 6.428a.791.791 0 0 1 .783.144.843.843 0 0 1 .237.338.832.832 0 0 1 .03.415c-.452 2.548-1.88 7.685-5.972 7.36a3.792 3.792 0 0 1-2.57-1.313 3.79 3.79 0 0 1-.888-2.746c.079-.999.55-1.921 1.314-2.569a3.75 3.75 0 0 1 2.742-.888 11.342 11.342 0 0 0 4.324-.74Zm0 0'
          transform='scale(.88889 .92308)'
        />
        <path
          fill='none'
          strokeWidth={1.5}
          strokeLinecap='round'
          strokeLinejoin='round'
          stroke='currentColor'
          d='M15.337 24.781v-7.68a6.404 6.404 0 0 1 6.403-6.399M1.74 24.781h10.398M18.54 24.781h7.199M1.74 15.184 16.94.783M12.138.783h4.803v3.999'
          transform='scale(.88889 .92308)'
        />
      </svg>
    </>
  )
}

IconGrowingPlant.propTypes = {
  srText: PropTypes.string,
  size: PropTypes.string,
  className: PropTypes.string,
}
export default IconGrowingPlant
